import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import JoinCommunity from '../components/landing/JoinCommunity';
import { mcgpTokenAddress } from '../blockchain/contracts';
import './Community.css';

const Community = () => {
  return (
    <div className="community-page">
      {/* Hero Section */}
      <section className="community-hero">
        <div className="hero-background"></div>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md="10" lg="8">
              <div className="hero-content">
                <h1 className="hero-title mb-4">MCGPchain Community</h1>
                <p className="hero-tagline mb-5">
                  Connect, share, and grow with like-minded individuals
                  passionate about blockchain technology and financial freedom.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Our Community Section */}
      <section className="about-community">
        <Container>
          <Row className="justify-content-center">
            <Col md="10" lg="8">
              <div className="section-head text-center mb-5">
                <h2 className="title">About Our Community</h2>
                <div className="title-line"></div>
              </div>
              <p className="text-light mb-4">
                The MCGPchain community is built on the principles of
                collaboration, education, and mutual support. We believe in
                creating an ecosystem where everyone has the opportunity to
                learn, contribute, and succeed.
              </p>
              <p className="text-light mb-4">
                By joining our community, you&apos;ll gain access to exclusive
                content, early announcements, and the opportunity to connect
                with our team and other community members directly.
              </p>
              <div className="text-center mt-5">
                <div className="token-info p-4 rounded">
                  <h3 className="mb-3">$MCGP Token</h3>
                  <p className="mb-2">
                    Contract Address:{' '}
                    <span className="token-address">{mcgpTokenAddress}</span>
                  </p>
                  <p>
                    The $MCGP token is the heart of our ecosystem, providing
                    utility and governance rights to holders.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Community Guidelines Section */}
      <section className="community-guidelines">
        <Container>
          <Row className="justify-content-center">
            <Col md="10" lg="8">
              <div className="section-head text-center mb-5">
                <h2 className="title">Community Guidelines</h2>
                <div className="title-line"></div>
              </div>
              <div className="guidelines-list">
                <div className="guideline-item">
                  <h4>Be Respectful</h4>
                  <p>
                    Treat everyone with respect. Disagreements are natural, but
                    always maintain civility.
                  </p>
                </div>
                <div className="guideline-item">
                  <h4>No Financial Advice</h4>
                  <p>
                    Our community is not a place for financial advice. All
                    investment decisions are your own responsibility.
                  </p>
                </div>
                <div className="guideline-item">
                  <h4>No Spam or Self-Promotion</h4>
                  <p>
                    Keep discussions relevant and avoid excessive self-promotion
                    or spam.
                  </p>
                </div>
                <div className="guideline-item">
                  <h4>Protect Your Privacy</h4>
                  <p>
                    Never share your private keys, wallet recovery phrases, or
                    personal information.
                  </p>
                </div>
                <div className="guideline-item">
                  <h4>Report Issues</h4>
                  <p>
                    If you encounter inappropriate content or behavior, please
                    report it to our moderators.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Social Links Section */}
      <JoinCommunity />
    </div>
  );
};

export default Community;
